// Required JS from local files
import {
   addInitialFunction,
   dfmAlert,
   redirectToRequiredLogin,
} from "./dfm5";

$(document).ready(function() {
   addInitialFunction(redirectToRequiredLogin);
   getTrainingEvents();
});

function getTrainingEvents() {
   $.ajax({
      url: "/api/training/events/central",   // ?includepast=1",
      type: "GET",
      contentType:false,
      processData: false,
      cache: false,
      success: function(data, textStatus, jqXHR){
         $.each(data.events, function(k,e) {
            addTrainingEventRow(e, false);
         });
         // Display a message if there are no training events.
         if (!data.events || data.events.length === 0) {
            $("#training-events").hide();
            $("#training-events").after("<p style='color: grey;'>There are no training sessions currently scheduled.</p>")
         }
      },
      error: function(jqXHR, textStatus, errorThrown){
         dfmAlert("There was an error getting these training events: <br><br><strong>"+jqXHR.responseText+"</strong>");
      }
   });

}


function generateTimeHTML() {
   var dialogHTML = "";
   for(var h=1; h<=22; h++) {
      for(var m=0; m<=45; m+=15) {
         var hStr = h>=10 ? h : "0"+h;
         var mStr = m>=10 ? m : "0"+m;
         dialogHTML+= "<option value='"+hStr+":"+mStr+":00'>"+(h>12 ? h-12 : h)+":"+mStr+" "+(h>=12 ? "pm" : "am")+"</option>";
      }
   }
   return dialogHTML;
}

function formatDate(date) {
   var minsStr = date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
   return MONTHS[date.getMonth()]+" "+ordinal_suffix_of(date.getDate())+" "+date.getFullYear()+" "+(date.getHours()>12 ? date.getHours()-12 : date.getHours())+":"+minsStr+(date.getHours()>=12 ? "pm" : "am");
}

const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sept","Oct","Nov","Dec"];

function addTrainingEventRow(event, isEditing) {
   var dateStart = new Date(event.timestart*1000);
   var dateEnd = new Date(event.timeend*1000);
   console.log("START "+event.timestart+" END: "+event.timeend);
   const rowHTML = "<tr id='event-"+event.treid+"'><td class='col-1'><h1>"+event.title+"</h1><h2>"+event._runByName+"</h2><p>"+event.description+"</p></td>"
      +"<td><div class='attending' style='display:none'>&#10003; You are attending this event</div>"+formatDate(dateStart)+"<br><small>"+((event.timeend-event.timestart)/60.0)+" mins</small><h3><a class='meet-link' style='display:none' href='"+event.url+"'>"+event.url.substr(8)+"</a></h3></td>"
      +"<td><button class='signup-button'>Sign Up</button>"
      +"<button class='cancel-button' style='display:none'>Cancel</button>"
      +"</td></tr>";
   if(isEditing)$("#event-"+event.treid).replaceWith(rowHTML);
   else $("#training-events").prepend(rowHTML);
   $("#event-"+event.treid).find(".signup-button").click(() => attendEvent(event.treid));
   $("#event-"+event.treid).find(".cancel-button").click(() => cancelEvent(event.treid));
   $("#event-"+event.treid).data("event", event);

   if(!isEditing)updateAttendance(event.treid, event._isCurrentUserAttending);
}



function attendEvent(eventId) {
   var url = "/api/training/attend/"+eventId;
   console.log(url);
   $.ajax({
      url: url,
      type: "POST",
      contentType:false,
      processData: false,
      cache: false,
      success: function(data, textStatus, jqXHR){
         console.log("[SuccessfullySignedUp] "+JSON.stringify(data));
         updateAttendance(eventId, true);
         dfmAlert("<h1>You're signed up!</h1><p>You should receive a Google Calendar invite to your school email address</p><p>If for any reason you don't receive this email, the Google Meet link is now visible on the event information on this page.<p>");
      },
      error: function(jqXHR, textStatus, errorThrown){
         dfmAlert("There was an error signing you up for this training event: <br><br><strong>"+jqXHR.responseText+"</strong>");
      }
   });
}

function cancelEvent(eventId) {
   var url = "/api/training/unattend/"+eventId;
   console.log(url);
   $.ajax({
      url: url,
      type: "POST",
      contentType:false,
      processData: false,
      cache: false,
      success: function(data, textStatus, jqXHR){
         console.log("[SuccessfullyCancelledAttendance] "+JSON.stringify(data));
         updateAttendance(eventId, false);
      },
      error: function(jqXHR, textStatus, errorThrown){
         dfmAlert("There was an error cancelling your attendance for this training event: <br><br><strong>"+jqXHR.responseText+"</strong>");
      }
   });
}


function updateAttendance(eventId, isAttending) {
   if(isAttending) {
      $("#event-"+eventId).find(".meet-link").show();
      $("#event-"+eventId).find(".signup-button").hide();
      $("#event-"+eventId).find(".cancel-button").show();
      $("#event-"+eventId).find(".attending").show();
   } else {
      $("#event-"+eventId).find(".meet-link").hide();
      $("#event-"+eventId).find(".signup-button").show();
      $("#event-"+eventId).find(".cancel-button").hide();
      $("#event-"+eventId).find(".attending").hide();

   }
}

function ordinal_suffix_of(i) {
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "<sup>st</sup>";
    }
    if (j == 2 && k != 12) {
        return i + "<sup>nd</sup>";
    }
    if (j == 3 && k != 13) {
        return i + "<sup>rd</sup>";
    }
    return i + "<sup>th</sup>";
}
